import Reflux from 'reflux';

const ConfigurationBundlesActions = Reflux.createActions({
  apply: { asyncResult: true },
  create: { asyncResult: true },
  delete: { asyncResult: true },
  export: { asyncResult: true },
  list: { asyncResult: true },
});

export default ConfigurationBundlesActions;



// WEBPACK FOOTER //
// ../graylog2-server/graylog2-web-interface/src/actions/configuration-bundles/ConfigurationBundlesActions.jsx